<!-- components/EditForm.vue -->
<template>
  <div class="edit-form">
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="玩家名称" prop="userName">
        <div class="input_button_div">
          <el-input v-model="form.userName" placeholder="请输入玩家名称"></el-input>
          <el-button type="success" @click="searchButtonF">搜索</el-button>
          <el-button type="success" @click="newUpload">新增队伍</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
  <div class="elment-api tag-div-s">
    <div class="tag-div-ch">
      <div class="taxt-w">关注：</div>
      <div class="tag-w">
        <TagStandard @iconClick="handleTagClickFollow" @nameClick="handleTagNameClick" :tagData="tagData.followTags" :iconMode="'remove'"></TagStandard>
      </div>
    </div>
    <div class="tag-div-ch">
      <div class="taxt-w">查询记录：</div>
      <div class="tag-w">
        <TagStandard @iconClick="handleTagClickQuery" @nameClick="handleTagNameClick" :tagData="tagData.queryTags" :iconMode="'peg'"></TagStandard>
      </div>
    </div>
  </div>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <div class="red_point" style="display: none;"></div>
    <el-tab-pane label="个人上传" name="first" class="tabs_content">
      <div class="user_div_inif">
        <SmartImageCard :items="perDataList" :config="perConfig"></SmartImageCard>
      </div>
    </el-tab-pane>
    <el-tab-pane label="同盟上传" name="second" class="tabs_content">
      <div class="user_div_inif">
        <SmartImageCard :items="groDataList" :config="groConfig"></SmartImageCard>
      </div>
    </el-tab-pane>
    <el-tab-pane label="SVIP" name="Three" class="tabs_content">
      <div class="user_div_inif">
        <SmartImageCard :items="VIPDataList" :config="VIPConfig"></SmartImageCard>
      </div>
    </el-tab-pane>
  </el-tabs>
  <ModalEI v-if="showModalIntroduce" v-model:visible="showModalIntroduce" titleValue="搜索介绍"
    @close="showModalIntroduce = false">
    <IntroducePage @close="showModalIntroduce = false" :introduceTextValue="searchTexts"
      @doNotShowAgain="doNotShowAgain" isShowButton_doNotShowAgain="true" />
  </ModalEI>

  <ModalEI v-if="showModalUp" v-model:visible="showModalUp" v-model:titleValue="titleValueGroup"
    @close="showModalUp = false">
    <UploadReportPageST @save="onUpload" @close="showModalUp = false" :nameData="nameData" />
  </ModalEI>
</template>

<script>
import request from '@/utils/request' // 引入你的封装请求
import { searchText } from './mainSTconfig'

export default {
  name: 'SearchPage',
  data() {
    return {
      form: { "userName": "" },
      activeName: 'first',
      temp: { "list": [], "dict": {}, "str": "", "int": 0 },
      ZHANBAO_BASE_URL: '//www.aboluo.site/api/zhanbao/',
      rules: {
        userName: [
          { required: true, message: '请输入玩家名称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ]
      },
      perDataList: [],
      perConfig: {
        cardWidth: '260px', // 控制卡片基准宽度
        imageHeight: '180px',
        actions: [
          {
            type: 'button',
            label: '删除',
            condition: (item) => item,
            style: { color: 'rgb(255 255 255)', backgroundColor: 'rgb(255 0 0)' },
            action: (item) => { console.log('删除', item); this.confirmDeletion(item); }
          },
          {
            type: 'text',
            label: (item) => item.CreatTime,
            condition: (item) => item,
            style: { color: 'rgb(0 0 0)' },
            action: (item) => { console.log('CreatTime', item.CreatTime); }
          },
          {
            type: 'text',
            label: 'VIP',
            condition: (item) => item.status === 1,
            style: { color: 'rgb(234 197 4)' },
            action: (item) => { console.log('VIP', item); }
          }
        ]
      },
      groDataList: [],
      groConfig: {
        cardWidth: '260px', // 控制卡片基准宽度
        imageHeight: '180px',
        actions: [
          {
            type: 'text',
            label: 'VIP',
            condition: (item) => item.status === 1,
            style: { color: 'rgb(234 197 4)' },
            action: (item) => { console.log('VIP', item); }
          },
          {
            type: 'text',
            label: (item) => item.CreatTime,
            condition: (item) => item,
            style: { color: 'rgb(0 0 0)' },
            action: (item) => { console.log('CreatTime', item.CreatTime); }
          }
        ]
      },
      VIPDataList: [],
      VIPConfig: {
        cardWidth: '260px', // 控制卡片基准宽度
        imageHeight: '180px',
        actions: [
          {
            type: 'text',
            label: 'VIP',
            condition: (item) => item.status === 1,
            style: { color: 'rgb(234 197 4)' },
            action: (item) => { console.log('VIP', item); }
          },
          {
            type: 'text',
            label: (item) => item.CreatTime,
            condition: (item) => item,
            style: { color: 'rgb(0 0 0)' },
            action: (item) => { console.log('CreatTime', item.CreatTime); }
          }
        ]
      },
      red_point_a_div: 0,
      red_point_b_div: 0,
      red_point_c_div: 0,
      isOrCreatPoint: false,
      showModalIntroduce: true,
      searchTexts: searchText,
      showModalUp: false,
      integral: 0,
      nameData: { 'name': null },
      tagData: { 'followTags': [], 'queryTags': [] },
      tagDataStr: 'Tag',
      modeTagOperation: 0
    }
  },
  methods: {
    async removeData() {
      let datas = this.temp.dict
      if (datas.fileName.replace(/\s+/g, '') == "" || datas.fileName == null) {
        this.$message.error('操作失败！暂无图片数据！');
        return;
      }
      let URL = "/deleteZhanBao/" + datas.fileName;
      try {
        await request.delete(URL, {});
        this.$message.success('删除成功');
        this.temp.dict = {};
        this.searchButtonF();
      } catch (err) {
        console.error('delete error:', err);
        this.$message.error('删除失败');
        this.temp.dict = {};
      }
    },
    async getSecureImageUrl(fileName) {
      try {
        // 1. 用 axios 下载文件 blob (axios 会自动带上你配置好的 Token)
        const response = await request.get(`//www.aboluo.site/api/view/zhanbao/${fileName}`, {
          responseType: 'blob'
        });

        // 2. 生成临时 URL
        const blobUrl = URL.createObjectURL(response.data);

        return blobUrl;
      } catch (error) {
        console.error('下载失败', error);
        return '';
      }
    },
    close() {
      this.$emit('close');
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      event;
      if (tab.props.name == "first") {
        // console.log("first");
      } else if (tab.props.name == "second") {
        // console.log("second");
      }
    },
    async searchButtonF() {
      // 清理旧数据 (如果之前有 blob: 链接才需要清理，现在都是 http: 链接，不需要 revoke)
      this.perDataList = [];
      this.red_point_a_div = 0;
      this.groDataList = [];
      this.red_point_b_div = 0;
      this.VIPDataList = [];
      this.red_point_c_div = 0;
      if (this.form.userName.replace(/\s+/g, '') == "" || this.form.userName == null) {
        this.$messageX.xiaoxiti("e", "请先输入玩家名称！");
        return;
      }

      try {
        const res = await request.post('/SearchReport', {
          userName: this.form.userName
        });

        const udsr = await request.post('/UpdateSearchRecords', {
          userName: this.form.userName
        });

        this.$messageX.xiaoxiti("c", res.message);

        const perData = res.response?.per || [];
        const groData = res.response?.gro || [];
        const VIPData = res.response?.VIP || [];
        const queryTags = udsr.response?.QueryHistoryName || '';
        this.tagData.queryTags = this.$messageX.organizeLabelData(queryTags, this.$messageX.retrieveIdentifier(this.tagDataStr), this.tagDataStr);

        // 【新增】时间格式化辅助函数
        const formatTime = (timeStr) => {
          if (!timeStr) return '';
          const date = new Date(timeStr);

          // 检查日期是否有效
          if (isNaN(date.getTime())) return timeStr;

          const year = date.getFullYear();
          // 月份需要 +1，且补零
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');

          return `${year}年${month}月${day}日${hours}时${minutes}分${seconds}秒 上传`;
        };

        // 辅助函数：直接映射，无需 await，无需异步
        const processList = (dataList, typeLabel) => {
          if (!dataList.length) return [];

          return dataList.map(item => {
            // 【核心修改】直接拼接完整 URL
            // 浏览器会自动处理：
            // 1. 携带 Cookie/Token (因为同域或已配置凭据)
            // 2. 检查缓存 (304 NOT MODIFIED)
            // 3. 渲染图片
            const directUrl = `${this.ZHANBAO_BASE_URL}${item.FileAdress}`;

            return {
              id: item.ID || `${typeLabel}_${item.FileAdress}`,
              url: directUrl, // 直接给 http://... 开头的字符串
              status: item.IsVIP,
              fileName: item.FileAdress,
              sourceType: typeLabel,
              CreatTime: formatTime(item.CreatTime)
            };
          });
        };

        // 同步执行，瞬间完成，没有网络延迟
        this.perDataList = processList(perData, 'per');
        this.groDataList = processList(groData, 'gro');
        this.VIPDataList = processList(VIPData, 'VIP');
        this.red_point_a_div = this.perDataList.length;
        this.CreatPoint();

      } catch (err) {
        console.log('搜索失败:', err);
        this.$messageX.xiaoxiti("e", err.message || "查询服务异常");
      }
    },
    confirmDeletion(item) {
      this.temp.dict = item;
      this.$messageX.tipWin({ "magess": "确定删除？", "magess_title": "提示" }, this.removeData, this.emptyFunction);
    },
    emptyFunction() {

    },
    CreatPoint() {
      if (!document.getElementById("point-pane-first")) {
        var sf = document.getElementsByClassName("user_div_inif")[0];
        var sfx = Object.keys(sf.dataset)[0];
        var a = document.createElement("div");
        a.className = "red_point";
        a.id = "point-pane-first";
        a.textContent = "0";
        a.dataset["v-3b47ea1a"] = "";
        var b = document.createElement("div");
        b.className = "red_point";
        b.id = "point-pane-second";
        b.textContent = "0";
        var c = document.createElement("div");
        c.className = "red_point";
        c.id = "point-pane-Three";
        c.textContent = "0";
        var pane_first = document.getElementById("tab-first");
        pane_first.style.position = "relative";
        a.dataset[sfx] = "";
        pane_first.appendChild(a);
        var pane_second = document.getElementById("tab-second");
        pane_second.style.position = "relative";
        b.dataset[sfx] = "";
        pane_second.appendChild(b);
        var pane_Three = document.getElementById("tab-Three");
        pane_Three.style.position = "relative";
        c.dataset[sfx] = "";
        pane_Three.appendChild(c);
        this.isOrCreatPoint = true;
      }
      document.getElementById("point-pane-first").textContent = this.perDataList.length;
      document.getElementById("point-pane-second").textContent = this.groDataList.length;
      document.getElementById("point-pane-Three").textContent = this.VIPDataList.length;
    },
    doNotShowAgain() {
      this.showModalIntroduce = false;
      localStorage.setItem("searchPageData", JSON.stringify({ "showModalIntroduce": false }));
    },
    newUpload() {
      this.showModalUp = true;
      if (this.form.userName.replace(/\s+/g, '') != '') {
        this.nameData.name = this.form.userName;
      }
    },
    onUpload(formData) {
      var storedData = JSON.parse(localStorage.getItem('userData'));
      localStorage.removeItem('userData');
      storedData.user.user.Integral = formData.response.add_integral + this.integral;
      localStorage.setItem('userData', JSON.stringify(storedData));
      this.integral = formData.response.add_integral + this.integral;
      this.$emit('isUpload', {
        'data': formData,
        'isUpload': true
      });
      this.searchButtonF();
    },
    async handleTagClickFollow(data) {
      this.modeTagOperation = 1;
      try {
        const res = await request.post('/UpdateFollowUserDe', {
          userName: data.name
        });
        res;
      } catch (err) {
        console.log('操作失败:', err);
        this.modeTagOperation = 0;
        this.$messageX.xiaoxiti("e", err.message || "查询服务异常");
      }
    },
    async handleTagClickQuery(data) {
      try {
        const res = await request.post('/UpdateFollowUser', {
          userName: data.name
        });
        res;
      } catch (err) {
        console.log('操作失败:', err);
        this.$messageX.xiaoxiti("e", err.message || "查询服务异常");
      }
    },
    refresh(data) {
      if (data.QueryHistoryName) {
        this.tagData.queryTags = this.$messageX.organizeLabelData(data.QueryHistoryName, this.$messageX.retrieveIdentifier(this.tagDataStr), this.tagDataStr);
      }
      if (data.FollowUserName) {
        this.tagData.followTags = this.$messageX.organizeLabelData(data.FollowUserName, this.$messageX.retrieveIdentifier(this.tagDataStr), this.tagDataStr);
      }else{
        if(this.modeTagOperation == 1){
          this.tagData.followTags = [];
          this.modeTagOperation = 0;
        }
      }
    },
    async getData(){
      try {
        const res = await request.post('/GetSearchAndFollowData', {});
        if (res.response.FollowUserName != null) {
          this.tagData.followTags = this.$messageX.organizeLabelData(res.response.FollowUserName, this.$messageX.retrieveIdentifier(this.tagDataStr), this.tagDataStr);
        }
        if (res.response.QueryHistoryName != null) {
          this.tagData.queryTags = this.$messageX.organizeLabelData(res.response.QueryHistoryName, this.$messageX.retrieveIdentifier(this.tagDataStr), this.tagDataStr);
        }
      } catch (err) {
        console.log('操作失败:', err);
        this.$messageX.xiaoxiti("e", err.message || "查询服务异常");
      }
    },
    handleTagNameClick(data) {
      this.form.userName = data.name;
      this.searchButtonF();
    }
  },
  mounted() {
    document.getElementsByClassName("modal-container")[0].style.height = "100%";
    document.getElementsByClassName("modal-container")[0].style.width = "100%";
    if (document.getElementById("tab-Three")) {
      document.getElementById("tab-Three").style.paddingRight = "20px";
    } else {
      setTimeout(() => {
        document.getElementById("tab-Three").style.paddingRight = "20px";
      }, 2000);
    }

    var searchPageData = JSON.parse(localStorage.getItem('searchPageData'));
    if (searchPageData) {
      if (searchPageData.showModalIntroduce === false) {
        this.showModalIntroduce = false;
      }
    }
    this.getData();

    this.$socket.on('updateSearchRecords', (data) => {
      if (this.$socket.diversion(data).success) {
        if (data.notify) {
          if (data.notifyType == 'message') {
            this.$messageX.xiaoxiti("i", data.message);
          } else if (data.notifyType == 'confirm') {
            confirm(data.message);
          } else {
            console.error('回传数据包错误！');
          }
        }
        this.refresh(data.op);
      }
    });
  }
}
</script>

<style scoped>
.elment-api{
  --div-taxt-w: 80px;
}

.tag-w{
  width: calc(100% - var(--div-taxt-w));
}

.taxt-w {
  width: var(--div-taxt-w);
}

.edit-form input {
  display: block;
  margin-bottom: 10px;
  padding: 6px;
}

.button-div {
  padding-top: 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-end;
  align-items: center;
}

.button_b {
  background-color: rgb(230 222 40);
  border: 1px solid rgb(230 222 40);
}

.user_div_inif {
  display: flex;
}

.tabs_content {
  height: 75vh;
  overflow: auto;
  border-radius: 15px;
}

.input_button_div {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.item {
  margin-top: 10px;
  margin-right: 40px;
}

.red_point {
  background-color: rgb(255, 0, 0);
  border-radius: 100%;
  width: 2vh;
  height: 2vh;
  color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  font-size: 3vw;
  position: absolute;
  top: 0;
  right: 0;
  padding-left: 0.5vh;
}

.tag-div-s {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100vw;
}

.tag-div-ch {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.var-element-value {
  --element-div-display: flex;
  --element-div-flex-direction-row: row;
  --element-div-flex-wrap-nowrap: nowrap;
  --element-div-align-content-center: center;
  --element-div-justify-content-flex-start: flex-start;
  --element-div-align-items-center: center;
}
</style>